export const GIT_HASH = import.meta.env.VITE_GIT_HASH
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY
